<template>
  <div class='vuegram-post'>
    <div class='header level'>
      <div class='level-left'>
        <figure class='image is-32x32'>
          <img :src='post.userImage' :alt="'Sabinov.online - ' + post.caption"/>
        </figure>
        <span class='username'>{{post.username}}</span>
      </div>
    </div>
    <div class='image-container'
      :class='post.filter'
      :style="{ backgroundImage: 'url(' + post.postImage + ')' }"
      @dblclick='like(post.id)'>
    </div>
    <div class='content'>
      <div class='heart'>
        <i class='far fa-thumbs-up fa-lg fa-2x'
          :class="{'fas': this.post.hasBeenLiked}"
          @click='like(post.id)'>
        </i>
      </div>
      <p class='likes'>{{post.likes}} páči sa</p>
      <p class='caption'><span>{{post.username}}:</span> {{post.caption}}</p>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { APIService } from '../APIService';
const apiService = new APIService();

export default {
  name: 'VuegramPost',
  props: {
    post: Object,
  },
  methods: {
    like(id) {
      this.post.likes = this.post.hasBeenLiked ? this.post.likes - 1 : this.post.likes + 1;
      this.post.hasBeenLiked = !this.post.hasBeenLiked;
      apiService.increaseLike(id, this.post.hasBeenLiked);
    },
  },
};
</script>

<style lang='scss' src='../styles/vuegram-post.scss'>
// Styles from stylesheet
</style>



// WEBPACK FOOTER //
// src/components/VuegramPost.vue